import { TicketReply } from '@/store/ticketsStore.d';

const userName = (ticketReply: TicketReply) => {
  if (ticketReply.user && ticketReply.user.name) {
    return ticketReply.user.name;
  }

  if (ticketReply.contact && ticketReply.contact.name) {
    return ticketReply.contact.name;
  }

  return ticketReply.from_email;
};

const avatar = (ticketReply: TicketReply) => {
  if (ticketReply.user && ticketReply.user.avatar_path) {
    return ticketReply.user.avatar_path;
  }

  return null;
};

const email = (ticketReply: TicketReply) => {
  if (ticketReply.user && ticketReply.user.email) {
    return ticketReply.user.email;
  }

  if (ticketReply.contact && ticketReply.contact.email) {
    return ticketReply.contact.email;
  }

  return ticketReply.from_email;
};

// TODO: Implement company for replies when available.
const company = (ticketReply: TicketReply) => null;

export default (ticketReply: TicketReply) => ({
  userName: userName(ticketReply),
  avatar: avatar(ticketReply),
  email: email(ticketReply),
  company: company(ticketReply),
});
